// Copyright (c) StrangeBee 2023

import { useEffect, useState } from 'react';

import './ImageWidget.scss';
import client from '@Client';

interface ImageWidgetProps {
    reportTemplateId: string;
    attachmentId?: string;
}

export const ImageWidget = ({ reportTemplateId, attachmentId }: ImageWidgetProps) => {
    const [url, setUrl] = useState<string>();

    useEffect(() => {
        setUrl(`${client.apiUrl}/v1/caseReportTemplate/${reportTemplateId}/attachment/${attachmentId}`);
    }, [attachmentId, reportTemplateId]);

    return <div className="image-widget">{url && <img src={url} />}</div>;
};
